/* eslint-disable flowtype/require-valid-file-annotation */

import React, { Component } from 'react'
import AppContextDialog from './appContextDialog'
import AuthWrapper from '../layouts/authWrapper'
import CoreLayout from '../layouts/coreLayout'
import { ForgotPasswordEmailExpired } from './forgotPasswordExpired';
import Group from './group'
import Groups from './groups'
import LoggedOut from './loggedOut'
import Messages from '../constants/messages'
import { nordAdmins, partnerAccessAdmin, partnerAccessAll } from '../constants/memberships'
import NotFound from './404'
import Permissions from './permissions'
import Profile from './profile'
import Registration from './registration'
import ForgotPassword from './forgotPassword'
import HeaderLayout from '../layouts/headerLayout';
import Roles from './roles'
import { Switch } from 'react-router'
import Unauthorized from './unauthorized'
import User from './user'
import Users from './users'
import withRoot from '../components/withRoot'

class Index extends Component {

  render() {
    return (
      <Switch>
        <AuthWrapper exact path="/" allowedMemberships={nordAdmins} allowedRoles={partnerAccessAdmin} component={Users} />
        <AuthWrapper exact path="/users" allowedMemberships={nordAdmins} allowedRoles={partnerAccessAdmin} component={Users} />
        <AuthWrapper exact path="/users/:userId" allowedMemberships={nordAdmins} allowedRoles={partnerAccessAdmin} component={User} />
        <AuthWrapper exact path="/groups" allowedMemberships={nordAdmins} allowedRoles={partnerAccessAdmin} component={Groups} />
        <AuthWrapper exact path="/groups/:id" allowedMemberships={nordAdmins} allowedRoles={partnerAccessAdmin} component={Group} />
        <AuthWrapper exact path="/roles" allowedMemberships={nordAdmins} allowedRoles={[]} component={Roles} />
        <AuthWrapper exact path="/appContextDialog" allowedMemberships={nordAdmins} allowedRoles={partnerAccessAll} component={AppContextDialog} />
        <AuthWrapper exact path="/permissions" allowedMemberships={nordAdmins} allowedRoles={[]} component={Permissions} />
        <AuthWrapper exact path="/profile" allowedMemberships={[]} allowedRoles={partnerAccessAll} component={Profile} />
        <CoreLayout exact path="/loggedOut" component={LoggedOut} />
        <HeaderLayout exact path="/application/:application/registration/:userId" component={Registration} title={Messages['pageHeaders']['USER_REGISTRATION_TITLE']} />
        <HeaderLayout exact path="/application/:application/reset-password/:userId" component={Registration} title={Messages['pageHeaders']['RESET_PASSWORD_TITLE']} /> {/* Admin Assisted email case */}
        <HeaderLayout exact path="/application/:application/user-registration-expired" component={Registration} title={Messages['pageHeaders']['USER_REGISTRATION_TITLE']} />
        <HeaderLayout exact path="/application/:application/reset-password-expired" component={Registration} title={Messages['pageHeaders']['RESET_PASSWORD_TITLE']} />
        <HeaderLayout exact path="/application/:application/forgot-password/:userId" component={ForgotPassword} title={Messages['pageHeaders']['RESET_PASSWORD_TITLE']} /> {/* User Self-Serve email case */}
        <HeaderLayout exact path="/application/:application/forgot-password-expired" component={ForgotPasswordEmailExpired} title={Messages['pageHeaders']['RESET_PASSWORD_TITLE']} />
        <CoreLayout exact path="/unauthorized" component={Unauthorized} />
        {/* /callback and login routes force the authorizing screen rather than 404 page after login redirects */}
        <AuthWrapper path="/callback" allowedMemberships={nordAdmins} allowedRoles={partnerAccessAll} component={Users} />
        <AuthWrapper path="/login" allowedMemberships={nordAdmins} allowedRoles={partnerAccessAll} component={Users} />
        <CoreLayout component={NotFound} />
      </Switch>
    )
  }
}

export default withRoot(Index)
